import { render, staticRenderFns } from "./JCommCommentsContents.vue?vue&type=template&id=59aa08e0&scoped=true&"
import script from "./JCommCommentsContents.vue?vue&type=script&lang=js&"
export * from "./JCommCommentsContents.vue?vue&type=script&lang=js&"
import style0 from "./JCommCommentsContents.vue?vue&type=style&index=0&id=59aa08e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aa08e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
